/**
 * Resolve the active PersonaId for a user. Template wins when set
 * (a user whose UserRole='tenant_admin' AND template='building_admin'
 * is a building_admin for UX purposes).
 *
 * Client-side fallback: the PublicUser shape on the wire today
 * doesn't expose `template` directly (server resolves it during
 * login but currently only flattens the sales_agent case into the
 * `is_sales_agent` boolean). Callers pass `is_sales_agent` through
 * when they have a PublicUser; this helper derives `'sales_agent'`
 * from it. When PublicUser eventually exposes other templates
 * (e.g. building_admin), extend the discriminator chain below in
 * lockstep with the server-side flattening.
 */
export function resolvePersonaId(user) {
    if (user.template)
        return user.template;
    if (user.is_sales_agent)
        return 'sales_agent';
    return user.role ?? null;
}
//# sourceMappingURL=persona.js.map